<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li [hidden]="contact.organization_id == null"><i class="pi pi-angle-right"></i></li>
    <li [hidden]="contact.organization_id == null"><a [routerLink]="['/organizations']">Organizaciones</a></li>
    <li [hidden]="contact.organization_id == null"><i class="pi pi-angle-right"></i></li>
    <li [hidden]="contact.organization_id == null"><a
            [routerLink]="['/organizations', 0, contact.organization_id]">{{contact.organization?.name}}</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/contacts']">Contactos</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li [hidden]="contact.id==null"><a [routerLink]="['/contacts', contact.id]">{{contact.name}}</a>
    </li>
</ul>
<app-view #view [code]="'contacts.edit'" [model]="contact" (onEvent)="onEvent($event)"></app-view>